module.exports = __webpack_public_path__ + "static/media/money-bill.d85add64.svg";